import { useCurrentAccountDetails } from 'api/current-account/currentAccount.hooks'
import { useIsLoggedIn } from 'gin-and-tonic/utils/access/useIsLoggedIn'
import { useFetchCurrentPartnerUser } from 'legacy/contexts/global/queries/currentPartnerUser'

export const useHaltRedirectAccessDetails = () => {
  const { loading: loadingCurrentPartnerUser } = useFetchCurrentPartnerUser({
    fetchPolicy: 'network-only',
  })

  const { loading: loadingLoggedIn, isLoggedIn } = useIsLoggedIn()

  const { loading: loadingAccount, account } = useCurrentAccountDetails({
    fetchPolicy: 'network-only',
  })

  // Need to wait for loadingCurrentPartnerUser here or the global context will have empty user data on initial login!
  // This can be removed as the usage of the user from the global context is removed (WIP)
  const loading = loadingAccount || loadingLoggedIn || loadingCurrentPartnerUser

  const retailerDashboardAccess = account?.policies.viewRetailerDashboardSection
  const canAccessRetailerDashboard = retailerDashboardAccess && isLoggedIn
  const authServiceRequired = account?.authServiceRequired

  return {
    loading,
    canAccessRetailerDashboard,
    authServiceRequired,
  }
}
